import * as types from "../types/dashboard.types";
import {
  postDashboardlist,
  getRiderCurrentOrder,
  getMetricsDashboard,
  getShiftsList,
  getRiderCurrentOrderV2
} from '../../services/dashboard.service';
import { validationErrors } from "../../utils/Helpers";

// export const getDashboardListAction = (data, name) => async (dispatch, getState) => {
//   let request_status = false;
//   let return_data = [];
//   try {
//     await postDashboardlist(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
//       if(res.data.code === 200){
//         res.data.data.store_name_local = name;
//         let rs_dashboard_data = {...getState().ZoneReducer.dashboardData, [`storeId_${data}`]: res.data.data};
//         dispatch({
//           type: types.SET_DASHBOARD_DATA,
//           payload: rs_dashboard_data,
//         });
//         return_data = res.data.data;
//         request_status = true;
//       }
//     });
//   } catch (e) { }
//   if (request_status) return return_data;
//   else return false;
// };

// export const getDashboardFilterAction = (data) => {
//   return async (dispatch) => {
//     dispatch({
//       type: types.SET_DASHBOARD_DATA_FILTER,
//       payload: data,
//     });
//   };
// };
// export const setDashboardDataAction = (data) => {
//   return async (dispatch) => {
//     dispatch({
//       type: types.SET_DASHBOARD_DATA,
//       payload: data,
//     });
//   };
// };


export const getRiderCurrentOrderAction = (data, storeID) => {
  return async (dispatch, getState) => {
    try {
      await getRiderCurrentOrder(getState().authReducer.token, getState().authReducer.user.id, data, storeID).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_RIDER_CURRENT_ORDER_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA,
            payload: res.data.pagination,
          });
          dispatch({
            type: types.SET_RIDER_CURRENT_ORDER_STOREID_DATA,
            payload: storeID,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getRiderCurrentOrderZoneAction = (data, storeID) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: types.SET_RIDER_CURRENT_ORDER_STOREID_DATA,
        payload: storeID,
      })
      // await getRiderCurrentOrder(getState().authReducer.token, getState().authReducer.user.id, data, storeID).then((res) => {
      //   if (res.data.code === 200) {
      //     dispatch({
      //       type: types.SET_RIDER_CURRENT_ORDER_DATA,
      //       payload: res.data.data,
      //     });
      //     dispatch({
      //       type: types.SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA,
      //       payload: res.data.pagination,
      //     });
      //    ;
      //   }
      // });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getRiderCurrentOrderActionV2 = (data, storeID) => {
  return async (dispatch, getState) => {
    try {
      await getRiderCurrentOrderV2(getState().authReducer.token, getState().authReducer.user.id, data, storeID).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_RIDER_CURRENT_ORDER_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA,
            payload: res.data.pagination,
          });
          dispatch({
            type: types.SET_RIDER_CURRENT_ORDER_STOREID_DATA,
            payload: storeID,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getRiderCurrentOrderZoneActionV2 = (data, storeID) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: types.SET_RIDER_CURRENT_ORDER_STOREID_DATA,
        payload: storeID,
      })
      // await getRiderCurrentOrder(getState().authReducer.token, getState().authReducer.user.id, data, storeID).then((res) => {
      //   if (res.data.code === 200) {
      //     dispatch({
      //       type: types.SET_RIDER_CURRENT_ORDER_DATA,
      //       payload: res.data.data,
      //     });
      //     dispatch({
      //       type: types.SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA,
      //       payload: res.data.pagination,
      //     });
      //    ;
      //   }
      // });
    } catch (e) {
      validationErrors(e);
    }
  };
};


export const getMetricsDashboardAction = (data) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.SET_METRICS_DASHBOARD_LOADER,
      payload: true,
    });
    try {
      await getMetricsDashboard(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_METRICS_DASHBOARD_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) { validationErrors(e) } finally {
      dispatch({
        type: types.SET_METRICS_DASHBOARD_LOADER,
        payload: false,
      });
    }
  };
};

export const filterMetricsDashboardAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_METRICS_DASHBOARD_FILTER,
      payload: data,
    });
  };
};

export const ShiftLevelListAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_SHIFTS_LOADING, payload: true});
      await getShiftsList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        dispatch({
          type: types.SET_SHIFTS_LIST,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_PAGINATION_SHIFTS_LIST,
          payload: res.data.pagination,
        });
      })
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({type: types.SET_SHIFTS_LOADING, payload: false});
    }
  };
};

export const LevelListAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_SHIFTS_LOADING, payload: true});
      await getShiftsList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        dispatch({
          type: types.SET_SHIFTS_MART_LIST,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_PAGINATION_SHIFTS_LIST,
          payload: res.data.pagination,
        });
      })
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({type: types.SET_SHIFTS_LOADING, payload: false});
    }
  };
};

export const martFilterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_MART_FILTER,
      payload: data,
    });
  };
};

export const shiftsFilterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_SHIFTS_FILTER,
      payload: data,
    });
  };
};